import styled from "styled-components/macro";
import { PrimaryButton, ButtonText, InputCheckbox } from "@loanbossinc/component-library";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
  align-items: center;
  padding: 1em;
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  height: 100%;
`;

export const RoundAvatar = styled.div`
  background: linear-gradient(212.88deg, #dfeffc 6.86%, rgba(249, 249, 249, 0) 116.99%);
  border-radius: 50%;
  height: 100px;
  margin: 1.5em 3.5em;
  width: 100px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const StepHeader = styled.div`
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  margin-bottom: 2em;
`;
export const StepInfo = styled.div`
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #5f6368;
  margin-bottom: 2em;
`;

export const LoansContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-height: 400px;
  overflow: auto;
  width: 90%;
`;

export const ButtonBar = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 90%;
  }
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  && {
    background: #005aa9;
    margin-top: 3em;
    width: auto;
    font-size: 13px;
  }
`;

export const BackButton = styled(ButtonText)`
  && {
    display: flex;
    justify-content: flex-start;
    margin-top: 3.5em;
    .label {
      margin-left: 1em;
    }
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0.8em;
  border-top: 1px solid #dadce0;
  height: 60px;
  border-bottom: ${props => props.last && "1px solid #dadce0"};
`;

export const StyledInputCheckbox = styled(InputCheckbox)`
  color: #005aa9 !important;
`;
